export const SHARING_REQUEST_MOTIVATION = {
  NEW_PROJECT: "new_project",
  JOIN_PROJECT: "access_data",
} as const
export type SharingRequestMotivation = typeof SHARING_REQUEST_MOTIVATION
export type SharingRequestMotivationType = SharingRequestMotivation[keyof SharingRequestMotivation]

export const SHARING_RESPONSE_MOTIVATION = {
  ALREADY_KNOWS_CUSTOMER: "knows_customer",
  PROJECT_NOT_POSSIBLE: "not_possible",
  NOT_COMPETENT: "not_competent",
  OTHER: "other",
} as const
export type SharingResponseMotivation = typeof SHARING_RESPONSE_MOTIVATION
export type SharingResponseMotivationType =
  SharingResponseMotivation[keyof SharingResponseMotivation]

export const SHARING_ABORT_MOTIVATION = {
  ABORTED_BY_CUSTOMER: "abort_by_customer",
  DONE_BY_OTHER: "done_by_other",
  PROJECT_NOT_POSSIBLE: "not_possible",
  NO_ARRANGEMENT_FOUND: "no_arrangement_found",
  OTHER: "other",
} as const
export type SharingAbortMotivation = typeof SHARING_ABORT_MOTIVATION
export type SharingAbortMotivationType = SharingAbortMotivation[keyof SharingAbortMotivation]
